/**
 * 数据分析模块路由
 * Sprint 1-18 开发路线图
 */

import { RouterView } from 'vue-router'

const dataAnalysisRoutes = {
  path: '/data-analysis-new',
  name: 'DataAnalysisNew',
  component: RouterView,
  meta: {
    title: '数据分析中心',
    icon: 'LineChartOutlined',
    permission: ['data-analysis']
  },
  children: [
    // ============================================
    // Sprint 1-2: 流向数据分析模块
    // ============================================
    {
      path: 'flow',
      name: 'FlowAnalysis',
      component: RouterView,
      meta: {
        title: '流向数据分析',
        icon: 'FundProjectionScreenOutlined',
        permission: ['data-analysis', 'flow-analysis']
      },
      children: [
        // 流向全景分析
        {
          path: 'overview',
          name: 'FlowOverview',
          component: () => import('@/views/data-analysis/flow/overview'),
          meta: {
            title: '流向全景分析',
            keepAlive: true,
            icon: 'DashboardOutlined',
            permission: ['data-analysis', 'flow-analysis']
          }
        },
        // 流向明细查询
        {
          path: 'detail',
          name: 'FlowDetail',
          component: () => import('@/views/data-analysis/flow/detail'),
          meta: {
            title: '流向明细查询',
            keepAlive: true,
            icon: 'TableOutlined',
            permission: ['data-analysis', 'flow-analysis']
          }
        },
        // 异常流向分析
        {
          path: 'abnormal',
          name: 'FlowAbnormal',
          component: () => import('@/views/data-analysis/flow/abnormal'),
          meta: {
            title: '异常流向分析',
            keepAlive: true,
            icon: 'WarningOutlined',
            permission: ['data-analysis', 'flow-analysis']
          }
        }
      ]
    },

    // ============================================
    // Sprint 3-4: 返利ROI分析模块
    // ============================================
    {
      path: 'rebate-roi',
      name: 'RebateROI',
      component: RouterView,
      meta: {
        title: '返利ROI分析',
        icon: 'FundOutlined',
        permission: ['data-analysis', 'rebate-roi']
      },
      children: [
        // 返利ROI综合仪表板 (Sprint 2 已完成)
        {
          path: 'dashboard',
          name: 'RebateROIDashboard',
          component: () => import('@/views/data-analysis/rebate-roi/dashboard'),
          meta: {
            title: 'ROI综合仪表板',
            keepAlive: true,
            icon: 'DashboardOutlined',
            permission: ['data-analysis', 'rebate-roi']
          }
        },
        // 返利ROI概览
        {
          path: 'overview',
          name: 'RebateROIOverview',
          component: () => import('@/views/data-analysis/rebate-roi/overview'),
          meta: {
            title: '返利ROI概览',
            keepAlive: true,
            icon: 'BarChartOutlined',
            permission: ['data-analysis', 'rebate-roi']
          }
        },
        // 多维度ROI分析 (Sprint 3)
        {
          path: 'multi-dimension',
          name: 'MultiDimensionROI',
          component: () => import('@/views/data-analysis/rebate-roi/multi-dimension'),
          meta: {
            title: '多维度ROI分析',
            keepAlive: true,
            icon: 'BarChartOutlined',
            permission: ['data-analysis', 'rebate-roi']
          }
        },
        // 政策效果对比 (Sprint 3)
        {
          path: 'policy-comparison',
          name: 'PolicyComparison',
          component: () => import('@/views/data-analysis/rebate-roi/policy-comparison'),
          meta: {
            title: '政策效果对比',
            keepAlive: true,
            icon: 'RadarChartOutlined',
            permission: ['data-analysis', 'rebate-roi']
          }
        },
        // 政策效果评估 (Sprint 3)
        {
          path: 'policy-effect',
          name: 'PolicyEffect',
          component: () => import('@/views/data-analysis/rebate-roi/policy-effect'),
          meta: {
            title: '政策效果评估',
            keepAlive: true,
            icon: 'FundViewOutlined',
            permission: ['data-analysis', 'rebate-roi']
          }
        },
        // 成本效益分析
        {
          path: 'cost-benefit',
          name: 'CostBenefit',
          component: () => import('@/views/data-analysis/rebate-roi/cost-benefit'),
          meta: {
            title: '成本效益分析',
            keepAlive: true,
            icon: 'LineChartOutlined',
            permission: ['data-analysis', 'rebate-roi']
          }
        }
      ]
    },

    // ============================================
    // Sprint 5-6: 客户洞察分析模块
    // ============================================
    {
      path: 'customer-insight',
      name: 'CustomerInsight',
      component: RouterView,
      meta: {
        title: '客户洞察分析',
        icon: 'TeamOutlined',
        permission: ['data-analysis', 'customer-insight']
      },
      children: [
        // 客户RFM概览 (Sprint 3)
        {
          path: 'rfm-overview',
          name: 'RFMOverview',
          component: () => import('@/views/data-analysis/customer-insight/rfm-overview'),
          meta: {
            title: '客户RFM概览',
            keepAlive: true,
            icon: 'DashboardOutlined',
            permission: ['data-analysis', 'customer-insight']
          }
        },
        // 客户分层列表 (Sprint 3)
        {
          path: 'rfm-list',
          name: 'RFMList',
          component: () => import('@/views/data-analysis/customer-insight/rfm-list'),
          meta: {
            title: '客户分层列表',
            keepAlive: true,
            icon: 'UnorderedListOutlined',
            permission: ['data-analysis', 'customer-insight']
          }
        },
        // RFM客户分群
        {
          path: 'rfm-segmentation',
          name: 'RFMSegmentation',
          component: () => import('@/views/data-analysis/customer-insight/rfm-segmentation'),
          meta: {
            title: 'RFM客户分群',
            keepAlive: true,
            icon: 'ClusterOutlined',
            permission: ['data-analysis', 'customer-insight']
          }
        },
        // 客户价值分析
        {
          path: 'value-analysis',
          name: 'CustomerValueAnalysis',
          component: () => import('@/views/data-analysis/customer-insight/value-analysis'),
          meta: {
            title: '客户价值分析',
            keepAlive: true,
            icon: 'RiseOutlined',
            permission: ['data-analysis', 'customer-insight']
          }
        },
        // 客户流失管理 (合并原有的流失风险分析和流失预警工作台)
        {
          path: 'churn-management',
          name: 'ChurnManagement',
          component: () => import('@/views/data-analysis/customer-insight/churn-management'),
          meta: {
            title: '客户流失管理',
            keepAlive: true,
            icon: 'AlertOutlined',
            permission: ['data-analysis', 'customer-insight']
          }
        },
        // 🔴 已废弃:流失风险分析 (已合并到churn-management)
        // {
        //   path: 'churn-warning',
        //   name: 'ChurnWarning',
        //   component: () => import('@/views/data-analysis/customer-insight/churn-warning'),
        //   meta: {
        //     title: '流失风险分析',
        //     keepAlive: true,
        //     icon: 'AlertOutlined',
        //     permission: ['data-analysis', 'customer-insight']
        //   }
        // },
        // 🔴 已废弃:客户流失预警工作台 (已合并到churn-management)
        // {
        //   path: 'churn-alert',
        //   name: 'ChurnAlert',
        //   component: () => import('@/views/data-analysis/customer-insight/churn-alert'),
        //   meta: {
        //     title: '流失预警工作台',
        //     keepAlive: true,
        //     icon: 'WarningOutlined',
        //     permission: ['data-analysis', 'customer-insight']
        //   }
        // },
        // Sprint 4: 标签管理
        {
          path: 'tag-management',
          name: 'TagManagement',
          component: () => import('@/views/data-analysis/customer-insight/tag-management'),
          meta: {
            title: '标签管理',
            keepAlive: true,
            icon: 'TagsOutlined',
            permission: ['data-analysis', 'customer-insight']
          }
        }
      ]
    },

    // ============================================
    // Sprint 7-9: 产品市场分析模块
    // ============================================
    {
      path: 'product-market',
      name: 'ProductMarket',
      component: RouterView,
      meta: {
        title: '产品市场分析',
        icon: 'ShoppingOutlined',
        permission: ['data-analysis', 'product-market']
      },
      children: [
        // 产品销量排名
        {
          path: 'sales-ranking',
          name: 'ProductSalesRanking',
          component: () => import('@/views/data-analysis/product-market/sales-ranking'),
          meta: {
            title: '产品销量排名',
            keepAlive: true,
            icon: 'TrophyOutlined',
            permission: ['data-analysis', 'product-market']
          }
        },
        // 市场占有率
        {
          path: 'market-share',
          name: 'MarketShare',
          component: () => import('@/views/data-analysis/product-market/market-share'),
          meta: {
            title: '市场占有率',
            keepAlive: true,
            icon: 'PieChartOutlined',
            permission: ['data-analysis', 'product-market']
          }
        },
        // 竞品对比分析
        {
          path: 'competitor-comparison',
          name: 'CompetitorComparison',
          component: () => import('@/views/data-analysis/product-market/competitor-comparison'),
          meta: {
            title: '竞品对比分析',
            keepAlive: true,
            icon: 'ForkOutlined',
            permission: ['data-analysis', 'product-market']
          }
        }
      ]
    },

    // ============================================
    // Sprint 10-12: 销售团队管理分析模块 (已完成 ✅)
    // ============================================
    {
      path: 'sales-team',
      name: 'SalesTeam',
      component: RouterView,
      meta: {
        title: '销售团队管理',
        icon: 'UsergroupAddOutlined',
        permission: ['data-analysis', 'sales-team']
      },
      children: [
        // 代表考核分析 (P0 - 已完成 ✅)
        {
          path: 'performance',
          name: 'SalesPerformance',
          component: () => import('@/views/data-analysis/sales-team/performance'),
          meta: {
            title: '代表考核分析',
            keepAlive: true,
            icon: 'UserOutlined',
            permission: ['data-analysis', 'sales-team']
          }
        },
        // 团队效能分析 (P1 - 已完成 ✅)
        {
          path: 'team-collaboration',
          name: 'TeamCollaboration',
          component: () => import('@/views/data-analysis/sales-team/team-collaboration'),
          meta: {
            title: '团队效能分析',
            keepAlive: true,
            icon: 'TeamOutlined',
            permission: ['data-analysis', 'sales-team']
          }
        },
        // 拜访管理分析 (P1 - 已完成 ✅)
        {
          path: 'task-management',
          name: 'TaskManagement',
          component: () => import('@/views/data-analysis/sales-team/task-management'),
          meta: {
            title: '拜访管理分析',
            keepAlive: true,
            icon: 'CalendarOutlined',
            permission: ['data-analysis', 'sales-team']
          }
        }
      ]
    },

    // ============================================
    // Sprint 13-15: 经营驾驶舱模块 (已完成 ✅)
    // ============================================
    {
      path: 'business-cockpit',
      name: 'BusinessCockpit',
      component: RouterView,
      meta: {
        title: '经营驾驶舱',
        icon: 'DashboardOutlined',
        permission: ['data-analysis', 'business-cockpit']
      },
      children: [
        // 核心指标监控 (P0 - 已完成 ✅)
        {
          path: 'core-metrics',
          name: 'CoreMetrics',
          component: () => import('@/views/data-analysis/business-cockpit/core-metrics'),
          meta: {
            title: '核心指标监控',
            keepAlive: true,
            icon: 'BarChartOutlined',
            permission: ['data-analysis', 'business-cockpit']
          }
        },
        // 智能预警中心 (P1 - 已完成 ✅)
        {
          path: 'business-alerts',
          name: 'BusinessAlerts',
          component: () => import('@/views/data-analysis/business-cockpit/business-alerts'),
          meta: {
            title: '智能预警中心',
            keepAlive: true,
            icon: 'BellOutlined',
            permission: ['data-analysis', 'business-cockpit']
          }
        },
        // 数据大屏 (已完成 ✅)
        {
          path: 'data-dashboard',
          name: 'DataDashboard',
          component: () => import('@/views/data-analysis/business-cockpit/data-dashboard'),
          meta: {
            title: '数据大屏',
            keepAlive: true,
            icon: 'FundProjectionScreenOutlined',
            permission: ['data-analysis', 'business-cockpit']
          }
        }
      ]
    }
  ]
}

export default dataAnalysisRoutes
